import React from 'react';
import './CompanyBasedStats.css';
import StarIcon from '@mui/icons-material/Star';
import { Link } from '@mui/material';

const CompanyBasedStats = (props) => {
  const {isSmallScreen} = props;
  return (
    <div className={isSmallScreen ? "company-stats-container-sm" : "company-stats-container"}>
      <div className="company-stat">
        <img loading="lazy" src='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRZprRrKCCXkzI6jLC9QdIf9pY3nTAL4cbf9w&s' style={{ width:isSmallScreen? '4rem' : '7rem', marginLeft:"auto", margin:"auto" }} />
        <div style={{display:"flex", marginTop: "5px", marginLeft:"auto", marginRight:"auto"}}><StarIcon style={{ color: "#faaf00" }} />
          <div style={{paddingTop:"3px", fontWeight:"400"}}>5/5</div>
        </div>
        <span className={isSmallScreen ? "company-stat-label-sm" : "company-stat-label"} style={{marginTop: "5px"}}><Link href="https://www.google.com/maps/place/PaperLive+Learning/@12.8820947,77.7528114,17z/data=!4m8!3m7!1s0x3bae73c7913df275:0xc3c282779cad685e!8m2!3d12.8820947!4d77.7528114!9m1!1b1!16s%2Fg%2F11w7jfdb6w?entry=ttu&g_ep=EgoyMDI0MDkxNS4wIKXMDSoASAFQAw%3D%3D">Click Here</Link></span>
      </div>
      <div className="company-stat">
        <img loading="lazy" src='https://upload.wikimedia.org/wikipedia/commons/thumb/0/01/LinkedIn_Logo.svg/1280px-LinkedIn_Logo.svg.png' style={{ width:isSmallScreen? '4rem' : '7rem',margin:"auto" }} />
        <div style={{display:"flex", marginTop: "5px", marginLeft:"auto", marginRight:"auto"}}>
          <StarIcon style={{ color: "#faaf00" }} />
        <div style={{paddingTop:"3px", fontWeight:"400"}}>5/5</div>
        </div>
        <span className={isSmallScreen ? "company-stat-label-sm" : "company-stat-label"} style={{marginTop: "5px"}}><Link href="https://www.linkedin.com/company/paperlive-learning/posts/?feedView=all">Click Here</Link></span>
      </div>
      <div className="company-stat">
        <img loading="lazy" src='https://upload.wikimedia.org/wikipedia/commons/thumb/e/e1/Logo_of_YouTube_%282015-2017%29.svg/1280px-Logo_of_YouTube_%282015-2017%29.svg.png' style={{ width:isSmallScreen? '3.5rem' : '5rem', margin:"auto"}} />
        <div style={{display:"flex", marginTop: "5px", marginLeft:"auto", marginRight:"auto"}}>
          <StarIcon style={{ color: "#faaf00" }} />
        <div style={{paddingTop:"3px", fontWeight:"400"}}>4.9/5</div>
        </div>
        <span className={isSmallScreen ? "company-stat-label-sm" : "company-stat-label"} style={{marginTop: "5px"}}><Link href="https://www.youtube.com/@PaperLiveLearning">Click Here</Link></span>
      </div>
    </div>
  );
};

export default CompanyBasedStats;